export type ThemeName = 'ambient-calm' | 'glass-depth' | 'cockpit' | 'retro-warm';
export type ThemeMode = 'light' | 'dark' | 'system';

export interface ThemePreset {
  name: ThemeName;
  label: string;
  description: string;
  previewColors: { bg: string; accent: string; surface: string };
}

export const THEME_PRESETS: ThemePreset[] = [
  {
    name: 'ambient-calm',
    label: 'Ambient Calm',
    description: 'Soft indigo tones, easy on the eyes',
    previewColors: { bg: '#0f172a', accent: '#818cf8', surface: '#1e293b' },
  },
  {
    name: 'glass-depth',
    label: 'Glass Depth',
    description: 'Frosted glass with deep purple undertones',
    previewColors: { bg: '#0c0a1e', accent: '#818cf8', surface: 'rgba(30,27,75,0.8)' },
  },
  {
    name: 'cockpit',
    label: 'Cockpit',
    description: 'Green-on-dark for night-shift monitoring',
    previewColors: { bg: '#031a0d', accent: '#4ade80', surface: '#052e16' },
  },
  {
    name: 'retro-warm',
    label: 'Retro Warm',
    description: 'Warm amber tones, cozy home vibes',
    previewColors: { bg: '#1c0e00', accent: '#fbbf24', surface: '#2d1a00' },
  },
];
